(function ($) {
  var $ = jQuery = $;
  $(document).ready(function () {
    window.digitalDataLayer = window.digitalDataLayer || [];
    $(".jfj-rolex-breadcrumbs").each(function () {
      let breadcrumbs = document.querySelector(".jfj-rolex-breadcrumbs ul");
      let crumbs = breadcrumbs.querySelectorAll("li");
      let quantity = crumbs.length;
      let last = quantity - 1;
      let toShowOnMobile = quantity > 3 ? quantity - 2 : 0;

      crumbs.forEach((crumb, i) => {
        if (i === last) {
          crumb.classList.add("active");
        }
        if (i === toShowOnMobile) {
          crumb.classList.add("mobile-active");
        }
      });
    });

    $(".jfj-rolex-slider").each(function () {
      var numberOfSlides = parseInt($(this).data('size'), 10);
      let slides = document.querySelectorAll(".jfj-rolex-slide");
      let currentSlide = 0;
      changeSlide();

      function setActiveDash(index) {
        if (index === 0) {
          document.querySelector('.slider-nav-left').classList.add("hidden");
        } else {
          document.querySelector('.slider-nav-left').classList.remove("hidden");
        }

        if (index === numberOfSlides - 1) {
          document.querySelector('.slider-nav-right').classList.add("hidden");
        } else {
          document.querySelector('.slider-nav-right').classList.remove("hidden");
        }

        document.querySelectorAll(".dash").forEach((dash, i) => {
          if (i === index) {
            dash.classList.add("active");
          } else {
            dash.classList.remove("active");
          }
        });
      }

      function changeSlide() {
        slides.forEach((slide, i) => {
          slide.style.transform = `translateX(-${currentSlide * 100}%)`;

          if (i === currentSlide) {
            slide.classList.add("active");
          } else {
            slide.classList.remove("active");
          }
        });

        setActiveDash(currentSlide % (numberOfSlides));
      }

      document.querySelector('.slider-nav-left').addEventListener("click", function () {
        if (currentSlide !== 0) {
          currentSlide = currentSlide - 1;
          changeSlide();
        }
      });

      document.querySelector('.slider-nav-right').addEventListener("click", function () {
        if (currentSlide !== numberOfSlides - 1) {
          currentSlide = currentSlide + 1;
        }
        changeSlide();
      });

      let dashContainer = document.createElement("div");
      dashContainer.classList.add("dashes");

      for (let i = 0; i < numberOfSlides; i++) {
        let dash = document.createElement("button");
        dash.classList.add("dash");

        const span = document.createElement("span");
        dash.appendChild(span);

        dash.addEventListener("click", function () {
          currentSlide = i;
          changeSlide();
        });

        dashContainer.appendChild(dash);
      }

      document.querySelector(".jfj-rolex-slider-container").appendChild(dashContainer);
      setActiveDash(0);
    });

    // $(document).ready(function () {
      $(".owl-carousel").owlCarousel({
        margin: 8,
        nav: true,
        slideBy: "page",
        responsive: {
          0: {
            items: 2,
            dotsEach: 2
          },
          768: {
            items: 3,
            dotsEach: 3
          },
          1025: {
            items: 4,
            dotsEach: 4
          }
        }
      });
    // });

    $(".model-details").each(function () {
      const modelPriceElement = this.querySelector(".body-2:not([data-price-formatted])");
      if (!modelPriceElement) return;
      const modelPriceText = modelPriceElement.textContent;
      const formattedPrice = new Intl.NumberFormat('en-US',).format(modelPriceText);
      modelPriceElement.textContent = `$${formattedPrice}`;
    });

    $(".jfj-rolex-static-map").each(function () {
      const dropdown = document.querySelector(".hours-dropdown");
      const toggle = dropdown.querySelector(".toggle");
      const caret = dropdown.querySelector(".caret");
      const hoursList = dropdown.querySelector(".hours");

      toggle.addEventListener("click", () => {
        toggle.classList.toggle("toggle-clicked");
        caret.classList.toggle("caret-rotate");
        hoursList.classList.toggle("hours-open")
      })

      const today = new Date().getDay();
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const day = days[today];
      const hours = hoursList.querySelectorAll("li");
      const show = dropdown.querySelector(".todays-hours");

      hours.forEach((hour, i) => {
        if (hour.textContent.includes(day)) {
          hour.classList.add("active");
          show.textContent = hour.textContent;
          if (!hour.textContent.includes("Closed")) {
            let openToday = document.createElement("span");
            openToday.textContent = "Open today: ";
            show.insertBefore(openToday, show.firstChild);
          }
        }
      });
    });

    $(".link-wrapper").each(function () {
      let callTrigger = document.querySelector("#call");
      let chatTrigger = document.querySelector("#chat");
      let directionsTrigger = document.querySelector("#get-directions");
      let findStoreTrigger = document.querySelector("#find-store");

      if (callTrigger) {
        callTrigger.addEventListener("click", () => {
          _satellite.track("contactCall");
        });
      }

      if (chatTrigger) {
        chatTrigger.addEventListener("click", () => {
          _satellite.track("whatsappContact");
        })
      }

      if (directionsTrigger) {
        directionsTrigger.addEventListener("click", () => {
          _satellite.track("getDirections");
        })
      }

      if (findStoreTrigger) {
        findStoreTrigger.addEventListener("click", () => {
          _satellite.track("findStore");
        })
      }
    });

    // rcpo model page cta tracking
    $(".rolex-cpo-product").each(function () {
      let addToBagTrigger = document.querySelector("#add-to-bag");
      let callTrigger = document.querySelector("#call");
      let chatTrigger = document.querySelector("#chat");
      let directionsTrigger = document.querySelector("#get-directions");
      let findStoreTrigger = document.querySelector("#find-store");

      if (addToBagTrigger) {
        addToBagTrigger.addEventListener("click", () => {
          _satellite.track("addToBag");
        });
      }

      if (callTrigger) {
        callTrigger.addEventListener("click", () => {
          _satellite.track("contactCall");
        });
      }

      if (chatTrigger) {
        chatTrigger.addEventListener("click", () => {
          _satellite.track("whatsappContact");
        })
      }

      if (directionsTrigger) {
        directionsTrigger.addEventListener("click", () => {
          _satellite.track("getDirections");
        })
      }

      if (findStoreTrigger) {
        findStoreTrigger.addEventListener("click", () => {
          _satellite.track("findStore");
        })
      }
    });

    $(".jfj-rolex-model-specs").each(function () {
      let downloadTrigger = document.querySelector("#download");
      if (downloadTrigger) {
        downloadTrigger.addEventListener("click", () => {
          _satellite.track("download");
        })
      }
    });

    $(".jfj-rolex-collection-grid").each(function () {
      let button = document.querySelector("#load-more-btn");
      button.addEventListener("click", () => {
        var hiddenBlocks = document.querySelectorAll('.collection-grid-item.hidden');

        for (var i = 0; i < 6 && i < hiddenBlocks.length; i++) {
          hiddenBlocks[i].classList.remove('hidden');
        }

        if (document.querySelectorAll('.collection-grid-item.hidden').length === 0) {
          button.style.display = 'none';
        }
      })
    });

    $(".jfj-rolex-contact-form").each(function () {
      const form = document.getElementById('contactForm');
      const heading = document.getElementById('heading');
      const steps = Array.from(document.getElementsByClassName('form-step'));
      const nextButton = document.getElementById('nextButton');
      const previousButton = document.getElementById('previousButton');
      let currentStep = 0;

      $(".form-accordion-header").each(function () {
        const accordionHeader = document.querySelector('.form-accordion-header');
        const image = document.querySelector('.contact-cover-image');
        const content = document.querySelector('.contact-section-wrapper');
        image.style.display = image.style.display = 'block';
        content.style.display = content.style.display = 'grid';
        accordionHeader.classList.add('active');

        accordionHeader.addEventListener('click', () => {
          const isActive = accordionHeader.classList.contains('active');

          if (isActive) {
            accordionHeader.classList.remove('active');
          } else {
            accordionHeader.classList.add('active');
          }

          image.style.display = image.style.display === 'block' ? 'none' : 'block';
          content.style.display = content.style.display === 'grid' ? 'none' : 'grid';
        });

        // Prevent click event propagation on .contact-section-wrapper itself
        document.querySelectorAll('.contact-section-wrapper').forEach(content => {
          content.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        });
      });

      function showStep(step) {
        if (step < 0 || step > 2) return;
        steps.forEach((s, index) => {
          s.classList.toggle('active', index === step);
          if (step === 0) {
            heading.textContent = "Please enter your message";
            document.getElementById('ty-image').style.display = 'none';
          } else if (step === 1) {
            heading.textContent = "Please enter your contact information";
            document.getElementById('ty-image').style.display = 'none';
          } else {
            heading.textContent = "Thank you";
            document.getElementById('ty-image').style.display = 'block';
          }
        });
      }

      nextButton.addEventListener('click', () => {
        currentStep++;
        showStep(currentStep);
      });

      previousButton.addEventListener('click', () => {
        currentStep--;
        showStep(currentStep);
      });

      function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }

      function validateForm(formData) {
        let valid = true;
        document.getElementById('firstNameError').style.display = 'none';
        document.getElementById('lastNameError').style.display = 'none';
        document.getElementById('emailError').style.display = 'none';
        document.getElementById('acceptTermsError').style.display = 'none';
        document.getElementById('communicationConsentError').style.display = 'none';
        
        if (formData.firstName === '') {
          document.getElementById('firstNameError').style.display = 'block';
          valid = false;
        }

        if (formData.lastName === '') {
          document.getElementById('lastNameError').style.display = 'block';
          valid = false;
        }

        if (formData.email === '' && formData.phoneNumber === '') {
          document.getElementById('emailError').style.display = 'block';
          valid = false;
        } else if (formData.email !== '' && !validateEmail(formData.email) && formData.phoneNumber === '') {
          document.getElementById('emailError').style.display = 'block';
          valid = false;
        }

        if (!formData.acceptTerms) {
          document.getElementById('acceptTermsError').style.display = 'block';
          valid = false;
        }

        // if (!formData.communicationConsent) {
        //   document.getElementById('communicationConsentError').style.display = 'block';
        //   valid = false;
        // }

        return valid;
      }

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        let formData = {
          message: document.querySelector('textarea[name="message"]').value.trim(),
          title: document.querySelector('select[name="title"]').value.trim(),
          firstName: document.querySelector('input[name="firstName"]').value.trim(),
          lastName: document.querySelector('input[name="lastName"]').value.trim(),
          email: document.querySelector('input[name="email"]').value.trim(),
          code: document.querySelector('input[name="code"]').value.trim(),
          phoneNumber: document.querySelector('input[name="phoneNumber"]').value.trim(),
          country: document.querySelector('select[name="country"]').value.trim(),
          storeCity: document.querySelector('select[name="storeCity"]').value.trim(),
          storeAddress: document.querySelector('select[name="storeAddress"]').value.trim(),
          acceptTerms: document.querySelector('input[name="acceptTerms"]').checked,
          communicationConsent: document.querySelector('input[name="communicationConsent"]').checked
        };

        let isValid = validateForm(formData);

        function scrollToElementWithOffset(el, offset = 100) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }

        if (isValid) {
          const request = new XMLHttpRequest();
          request.open(
            "POST",
            "https://hooks.zapier.com/hooks/catch/19576798/2u5rwn6/",
          );
          request.send(JSON.stringify(formData));

          request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
              // console.log(request.responseText);
              currentStep = 2;
              showStep(currentStep);
              scrollToElementWithOffset(document.getElementById('heading'), 250);
              _satellite.track("contactForm");
            }
          };
        }
      });

      // Show the first step initially
      showStep(currentStep);
    });
  });

  // watch model accordion
  document.addEventListener("DOMContentLoaded", () => {
    const accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(header => {
      header.classList.remove('active');

      header.addEventListener('click', () => {
        const isActive = header.classList.contains('active');
        const content = header.nextElementSibling;

        if (isActive) {
          header.classList.remove('active');
        } else {
          header.classList.add('active');
        }

        content.style.display = content.style.display === 'block' ? 'none' : 'block';

        // Close other open accordion items
        document.querySelectorAll('.accordion-content').forEach(item => {
          if (item !== content) {
            item.style.display = 'none';
            const otherHeader = item.previousElementSibling;
            otherHeader.classList.remove('active');
          }
        });
      });
    });

    // Prevent click event propagation on .accordion-content itself
    document.querySelectorAll('.accordion-content').forEach(content => {
      content.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  });

  // watch model image gallery
  document.addEventListener('DOMContentLoaded', function () {
    const isDesktop = () => window.innerWidth >= 768;
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightboxImage');
    const lightboxDashes = document.getElementById('lightboxDashes');
    const mainImage = document.getElementById('mainImage');
    const thumbnails = document.getElementById('thumbnails');
    const mobileDashes = document.getElementById('mobileDashes');
    const carousel = document.getElementById('carousel');
    const desktopImages = Array.from(thumbnails.querySelectorAll('img')).map(img => img.src);

    let startX = 0;
    let scrollLeft = 0;
    let isDown = false;
    let currentIndex = 0;

    function updateDashes(container, activeIndex, count, onDashClick) {
      container.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const button = document.createElement('button');
        button.classList.add('dash');
        if (i === activeIndex) button.classList.add('active');
        button.setAttribute('aria-label', `View image ${i + 1}`);

        if (typeof onDashClick === 'function') {
          button.addEventListener('click', () => onDashClick(i));
        }

        container.appendChild(button);
      }
    }

    // Initial render
    if (isDesktop()) {
      document.querySelector('.desktop-gallery').style.display = 'grid';
    } else {
      if (carousel && mobileDashes && carousel.children.length > 0) {
        // Initial render of dots
        updateDashes(mobileDashes, 0, carousel.children.length, (i) => {
          carousel.scrollTo({
            left: carousel.clientWidth * i,
            behavior: 'smooth'
          });
        });

        // Update dots on scroll
        carousel.addEventListener('scroll', () => {
          const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
          updateDashes(mobileDashes, index, carousel.children.length, (i) => {
            carousel.scrollTo({
              left: carousel.clientWidth * i,
              behavior: 'smooth'
            });
          });
        });
      }
    }

    // Touch start
    carousel?.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    }, { passive: true });

    // Touch move
    carousel?.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - carousel.offsetLeft;
      const walk = (startX - x); // scroll-fastness factor
      carousel.scrollLeft = scrollLeft + walk;
    }, { passive: true });

    // Touch end
    carousel?.addEventListener('touchend', () => {
      isDown = false;
    });

    // Lightbox
    function openLightbox(index) {
      currentIndex = index;
      lightboxImage.src = desktopImages[index];
      updateDashes(lightboxDashes, index, desktopImages.length, (i) => openLightbox(i));
      lightbox.style.display = 'flex';
      document.body.classList.add('body-no-scroll');
    }

    document.getElementById('next').addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % desktopImages.length;
      openLightbox(currentIndex);
    });

    document.getElementById('prev').addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + desktopImages.length) % desktopImages.length;
      openLightbox(currentIndex);
    });

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) lightbox.style.display = 'none';
    });

    // Desktop event listeners
    mainImage?.addEventListener('click', () => openLightbox(0));
    thumbnails?.querySelectorAll('img').forEach((img, index) => {
      img.addEventListener('click', () => openLightbox(index));
    });

    document.getElementById('lightboxClose').addEventListener('click', () => {
      lightbox.style.display = 'none';
      document.body.classList.remove('body-no-scroll');
    });

    // Optional: handle responsive layout switching
    window.addEventListener('resize', () => location.reload());

    document.addEventListener('keydown', function (event) {
      if (lightbox.style.display === 'flex') {
        if (event.key === 'ArrowRight') {
          currentIndex = (currentIndex + 1) % desktopImages.length;
          openLightbox(currentIndex);
        } else if (event.key === 'ArrowLeft') {
          currentIndex = (currentIndex - 1 + desktopImages.length) % desktopImages.length;
          openLightbox(currentIndex);
        } else if (event.key === 'Escape') {
          lightbox.style.display = 'none';
        }
      }
    });
  });

  // main rolex section menu active state
  document.addEventListener("DOMContentLoaded", function () {
    // Remove trailing slashes for consistent matching
    function normalizePath(path) {
      return path.replace(/\/+$/, '').toLowerCase();
    }

    const currentPath = normalizePath(window.location.pathname);

    const rolexMenuRules = [
      {
        matchPath: "/pages/discover-rolex",
        href: "/pages/discover-rolex"
      },
      {
        matchPath: "/pages/rolex-watches",
        href: "/pages/rolex-watches"
      },
      {
        matchPath: "/pages/rolex-new-watches",
        href: "/pages/rolex-new-watches"
      },
      {
        matchPath: "/pages/rolex-accessories",
        href: "/pages/rolex-accessories"
      },
      {
        matchPath: "/pages/rolex-watchmaking",
        href: "/pages/rolex-watchmaking"
      },
      {
        matchPath: "/pages/servicing-your-rolex",
        href: "/pages/servicing-your-rolex"
      },
      {
        matchPath: "/pages/world-of-rolex",
        href: "/pages/world-of-rolex"
      },
      {
        matchPath: "/pages/rolex-at-james-free",
        href: "/pages/rolex-at-james-free"
      },
      {
        matchPath: "/pages/rolex-contact",
        href: "/pages/rolex-contact"
      }
    ];

    const navLinks = document.querySelectorAll(".rolex-menu a[href]");

    for (const rule of rolexMenuRules) {
      if (normalizePath(rule.matchPath) === currentPath) {
        for (const link of navLinks) {
          const linkPath = normalizePath(new URL(link.href, window.location.origin).pathname);

          if (linkPath === normalizePath(rule.href)) {
            link.classList.add("active");
            return;
          }
        }
      }
    }
  });

  // main rolex section explore links active state
  document.addEventListener("DOMContentLoaded", function () {
    const currentFullUrl = window.location.href;
    const rolexMenuRules = [
      {
        fullUrl: "https://jamesfree.com/pages/discover-rolex"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-watches"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-accessories"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-watchmaking"
      },
      {
        fullUrl: "https://jamesfree.com/pages/servicing-your-rolex"
      },
      {
        fullUrl: "https://jamesfree.com/pages/world-of-rolex"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-contact"
      }
    ];

    const exploreLinks = document.querySelectorAll("a[href].exploring");

    for (const rule of rolexMenuRules) {
      if (rule.fullUrl === currentFullUrl) {
        for (const exploreLink of exploreLinks) {
          const exploreLinkUrl = exploreLink.href;

          if (exploreLinkUrl === currentFullUrl) {
            exploreLink.classList.add("active");
            return;
          }
        }
      }
    }
  });

  // rolex new watch collection explore links active state
  document.addEventListener("DOMContentLoaded", function () {
    const currentFullUrl = window.location.href;
    const collectionMenuRules = [
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/land-dweller"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/gmt-master-ii"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/oyster-perpetual"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/1908"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/datejust"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-new-watches/exclusive-dials"
      }
    ];

    const exploreLinks = document.querySelectorAll("a[href].exploring");

    for (const rule of collectionMenuRules) {
      if (rule.fullUrl === currentFullUrl) {
        for (const exploreLink of exploreLinks) {
          const exploreLinkUrl = exploreLink.href;

          if (exploreLinkUrl === currentFullUrl) {
            exploreLink.classList.add("active");
            return;
          }
        }
      }
    }
  });

  // rcpo menu active state
  document.addEventListener("DOMContentLoaded", function () {
    // Remove trailing slashes for consistent matching
    function normalizePath(path) {
      return path.replace(/\/+$/, '').toLowerCase();
    }

    const currentPath = normalizePath(window.location.pathname);

    const rcpoMenuRules = [
      {
        matchPath: "/pages/rolex-certified-pre-owned",
        href: "/pages/rolex-certified-pre-owned"
      },
      {
        matchPath: "/collections/rolex-certified-pre-owned-watches",
        href: "/collections/rolex-certified-pre-owned-watches"
      },
      {
        matchPath: "/pages/rolex-certified-pre-owned-the-program",
        href: "/pages/rolex-certified-pre-owned-the-program"
      },
      {
        matchPath: "/pages/the-rolex-certification",
        href: "/pages/the-rolex-certification"
      },
      {
        matchPath: "/pages/rolex-certified-pre-owned-contact-us",
        href: "/pages/rolex-certified-pre-owned-contact-us"
      }
    ];

    const navLinks = document.querySelectorAll(".rolex-menu a[href]");

    for (const rule of rcpoMenuRules) {
      if (normalizePath(rule.matchPath) === currentPath) {
        for (const link of navLinks) {
          const linkPath = normalizePath(new URL(link.href, window.location.origin).pathname);

          if (linkPath === normalizePath(rule.href)) {
            link.classList.add("active");
            return;
          }
        }
      }
    }
  });

  // rcpo explore links active state
  document.addEventListener("DOMContentLoaded", function () {
    const currentFullUrl =  window.location.href;
    const rcpoMenuRules = [
      {
        fullUrl: "https://jamesfree.com/pages/rolex-certified-pre-owned"
      },
      {
        fullUrl: "https://jamesfree.com/collections/rolex-certified-pre-owned-watches"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-certified-pre-owned-the-program"
      },
      {
        fullUrl: "https://jamesfree.com/pages/the-rolex-certification"
      },
      {
        fullUrl: "https://jamesfree.com/pages/rolex-certified-pre-owned-contact-us"
      }
    ];

    const exploreLinks = document.querySelectorAll("a[href].exploring");

     for (const rule of rcpoMenuRules) {
      if (rule.fullUrl === currentFullUrl) {
        for (const exploreLink of exploreLinks) {
          const exploreLinkUrl = exploreLink.href;

          if (exploreLinkUrl === currentFullUrl) {
            exploreLink.classList.add("active");
            return;
          }
        }
      }
    }
  });

})(theme.jQuery); 
